import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material'
import { useTranslation } from "react-i18next";

export default function CustomAccordion( { children, title, key, defaultExpanded = true, testId} ) {
  const {t} = useTranslation();

    return (
        <Accordion
            key={key}
            defaultExpanded={defaultExpanded}
            elevation={0}
            sx={{
                "&:before": {
                display: "none", // Remove the default border
                },
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 2,
            }}
            >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                data-testid={testId && `${testId}.trigger`}
                sx={{
                backgroundColor: "transparent",
                minHeight: "48px !important",
                "& .MuiAccordionSummary-content": {
                    my: 1,
                },
                }}
            >
                <Typography variant="subtitle1" fontWeight="medium">
                {t(title)}
                </Typography> 
            </AccordionSummary>
            <AccordionDetails sx={{ pt: 0 }}>
                {children}
            </AccordionDetails>
        </Accordion>
  )
}
